import React from 'react';
import styles from '../irlObservations2026.module.css';
import { PriorityMark } from '../chrome';
import { Confidence, SuggestHeader, SuggestTabs, SuggestionEdit, stripHtmlText, suggestionCardKey } from './shared';

export default function IRL_AI_Review_Review_Suggestions_Observations({
    tab,
    tabs,
    onTab,
    onBack,
    items,
    counts,
    reviewMeta,
    onAccept,
    onDismiss,
    busy,
}) {
    const [editingId, setEditingId] = React.useState(null);
    const [editText, setEditText] = React.useState('');
    return (
        <>
            <SuggestHeader onBack={onBack} meta={reviewMeta} />
            <SuggestTabs tabs={tabs} tab={tab} onTab={onTab} counts={counts} />
            <div className={styles.detailBody}>
                {items.map(item => {
                    const done = item.status === 'ACCEPTED' || item.status === 'DISMISSED';
                    const cardKey = suggestionCardKey(item);
                    const title = stripHtmlText(item.title);
                    const body = stripHtmlText(item.body);
                    const editing = editingId === cardKey;
                    return (
                        <div key={cardKey} className={styles.suggestCard}>
                            <div className={styles.suggestTitleRow}>
                                <div>
                                    <div className={styles.suggestId}>Proposed Observation</div>
                                    <div className={styles.rowTitle}>{title}</div>
                                </div>
                                <div className={styles.detailMeta}>
                                    <PriorityMark value={item.materiality} suffix="materiality" />
                                    <Confidence value={item.confidence} />
                                </div>
                            </div>
                            {editing ? (
                                <SuggestionEdit
                                    value={editText}
                                    onChange={setEditText}
                                    onSave={() => {
                                        onAccept?.(item, editText);
                                        setEditingId(null);
                                    }}
                                    onCancel={() => setEditingId(null)}
                                    disabled={busy || done}
                                />
                            ) : (
                                <p className={styles.responseBody}>{body}</p>
                            )}
                            <div className={styles.actionRow}>
                                <button
                                    type="button"
                                    className={styles.primaryBtn}
                                    onClick={() => onAccept?.(item)}
                                    disabled={done || busy}>
                                    {item.status === 'ACCEPTED' ? 'Accepted' : 'Accept'}
                                </button>
                                {!editing && (
                                    <button
                                        type="button"
                                        className={styles.outlineBtn}
                                        onClick={() => {
                                            setEditingId(cardKey);
                                            setEditText(body);
                                        }}
                                        disabled={done || busy}>
                                        Edit & accept
                                    </button>
                                )}
                                <button type="button" className={styles.mutedBtn} onClick={() => onDismiss?.(item)} disabled={done || busy}>
                                    {item.status === 'DISMISSED' ? 'Dismissed' : 'Reject'}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
